import { COLORS } from '../../../utils/Application_Constants';

const ExpenseStatusEnum = {
    0: { value: 'PendingSubmission', UI: 'Pending Submission' },
    1: { value: 'Submitted', UI: 'Submitted' },
    2: { value: 'InProcess', UI: 'In Process' },
    3: { value: 'TcApproved', UI: 'TC Approved' },
    4: { value: 'New', UI: 'New' },
    5: { value: 'ReadyForReview', UI: 'Ready for Review' },
    6: { value: 'NeedsApproval', UI: 'Needs Approval' },
    7: { value: 'NonReimbursable', UI: 'Non-Reimbursable' },
    8: { value: 'Rejected', UI: 'Rejected' },
    9: { value: 'NeedMoreInformation', UI: 'Need More Information' },
    10: { value: 'ReturnedByAccounting', UI: 'Returned by Accounting' },
    11: { value: 'OnHoldMatchPending', UI: 'Match Pending' },
    12: { value: 'OnHoldPendingAirfare', UI: 'Pending Airfare' },
    13: { value: 'OnHoldAirlineCreditOnFile', UI: 'Airline Credit On File' },
    14: { value: 'OnHoldDisputed', UI: 'Disputed' },
    15: { value: 'OnHoldAdvancedDeposit', UI: 'Advanced Deposit' },
    16: { value: 'OnHoldReimbursement', UI: 'Reimbursement On Hold' },
    17: { value: 'Abandoned', UI: 'Abandoned' },
    18: { value: 'Matched', UI: 'Matched' },
    19: { value: 'Approved', UI: 'Approved' },
    20: { value: 'Posted', UI: 'Posted' },
    21: { value: 'Dispute', UI: 'Dispute' },
    22: { value: 'ToBeSentToWorkday', UI: 'To Be Sent to Workday' },
    23: { value: 'AwaitingEndDate', UI: 'Awaiting End Date' },
    24: { value: 'MCOCredit', UI: 'MCO/Credit' },
    25: { value: 'Processed', UI: 'Processed' },
    26: { value: 'Grouped', UI: 'Grouped' },
    27: { value: 'Invoiced', UI: 'Invoiced' },
    28: { value: 'InCorrection', UI: 'In Correction' },
    29: { value: 'Outdated', UI: 'Outdated' },
    30: { value: 'InvoiceReview', UI: 'Invoice Review' },
    31: { value: 'ReviewOnHold', UI: 'Review On Hold' },
    32: { value: 'AwaitingRefund', UI: 'Awaiting Refund' },
    33: { value: 'AnticipateRefund', UI: 'Anticipate Refund' },
    34: { value: 'AwaitingReceipt', UI: 'Awaiting Receipt' },
    35: { value: 'Hold', UI: 'Hold' },
    36: { value: 'WorkdayError', UI: 'Workday Error' },
};

const ExpenseClinicianReimbursementStatusEnum = {
    1: { value: 'Abandoned', UI: 'Abandoned' },
    2: { value: 'Approved', UI: 'Approved' },
    3: { value: 'InCorrection', UI: 'In Correction' },
    4: { value: 'Invoiced', UI: 'Invoiced' },
    5: { value: 'InProcess', UI: 'In Process' },
    6: { value: 'InvoiceReview', UI: 'Invoice Review' },
    7: { value: 'NeedMoreInformation', UI: 'Need More Information' },
    8: { value: 'NonReimbursable', UI: 'Non-Reimbursable' },
    9: { value: 'PendingSubmission', UI: 'Pending Submission' },
    10: { value: 'Posted', UI: 'Posted' },
    11: { value: 'ReadyForReview', UI: 'Ready for Review' },
    12: { value: 'OnHoldReimbursement', UI: 'Reimbursement On Hold' },
    13: { value: 'ReturnedByAccounting', UI: 'Returned by Accounting' },
    14: { value: 'Submitted', UI: 'Submitted' },
    15: { value: 'TcApproved', UI: 'TC Approved' },
    16: { value: 'ReviewOnHold', UI: 'Review On Hold' },
    17: { value: 'WorkdayError', UI: 'Workday Error' },
};

const ExpenseVaultStatusEnum = {
    1: { value: 'ReadyForReview', UI: 'Ready for Review' },
    2: { value: 'NeedsApproval', UI: 'Needs Approval' },
    3: { value: 'Approved', UI: 'Approved' },
    4: { value: 'Posted', UI: 'Posted' },
    5: { value: 'Invoiced', UI: 'Invoiced' },
    6: { value: 'InvoiceReview', UI: 'Invoice Review' },
    7: { value: 'InCorrection', UI: 'In Correction' },
    8: { value: 'Abandoned', UI: 'Abandoned' },
    9: { value: 'WorkdayError', UI: 'Workday Error' },
};

const ExpensePaymentStatusEnum = {
    1: { value: 'Abandoned', UI: 'Abandoned' },
    2: { value: 'Approved', UI: 'Approved' },
    3: { value: 'InProcess', UI: 'In Process' },
    4: { value: 'PendingSubmission', UI: 'Pending Submission' },
    5: { value: 'Posted', UI: 'Posted' },
    6: { value: 'ReadyForReview', UI: 'Ready for Review' },
    7: { value: 'Rejected', UI: 'Rejected' },
    8: { value: 'Submitted', UI: 'Submitted' },
    9: { value: 'Invoiced', UI: 'Invoiced' },
    10: { value: 'InvoiceReview', UI: 'Invoice Review' },
    11: { value: 'InCorrection', UI: 'In Correction' },
    12: { value: 'ReviewOnHold', UI: 'Review On Hold' },
    13: { value: 'WorkdayError', UI: 'Workday Error' },
};

const ExpenseCreditCardStatusEnum = {
    1: { value: 'Approved', UI: 'Approved' },
    2: { value: 'AwaitingEndDate', UI: 'Awaiting End Date' },
    3: { value: 'Grouped', UI: 'Grouped' },
    4: { value: 'Invoiced', UI: 'Invoiced' },
    5: { value: 'InProcess', UI: 'In Process' },
    6: { value: 'InCorrection', UI: 'In Correction' },
    7: { value: 'InvoiceReview', UI: 'Invoice Review' },
    8: { value: 'OnHoldMatchPending', UI: 'Match Pending' },
    9: { value: 'MCOCredit', UI: 'MCO/Credit' },
    10: { value: 'Posted', UI: 'Posted' },
    11: { value: 'Processed', UI: 'Processed' },
    12: { value: 'ReadyForReview', UI: 'Ready for Review' },
    13: { value: 'ToBeSentToWorkday', UI: 'To Be Sent to Workday' },
    14: { value: 'Matched', UI: 'Matched' },
    15: { value: 'Disputed', UI: 'Disputed' },
    16: { value: 'AwaitingRefund', UI: 'Awaiting Refund' },
    17: { value: 'AnticipateRefund', UI: 'Anticipate Refund' },
    18: { value: 'AwaitingReceipt', UI: 'Awaiting Receipt' },
    19: { value: 'Hold', UI: 'Hold' },
    20: { value: 'WorkdayError', UI: 'Workday Error' },
};

const ExpenseStatusIdsEnum = {
    New: 0,
    InProcess: 1,
    ReadyForReview: 2,
    Rejected: 3,
    OnHoldMatchPending: 4,
    OnHoldPendingAirfare: 5,
    OnHoldAirlineCreditOnFile: 6,
    OnHoldDisputed: 7,
    OnHoldAdvancedDeposit: 8,
    OnHoldReimbursement: 9,
    Abandoned: 10,
    Matched: 11,
    Approved: 12,
    Posted: 13,
    TcApproved: 14,
    NeedMoreInformation: 15,
    Submitted: 16,
    NonReimbursable: 17,
    PendingSubmission: 18,
    ReturnedByAccounting: 19,
    NeedsApproval: 20,
    Invoiced: 21,
};

const ExpenseStatusValuesEnum = {
    PendingSubmission: 'PendingSubmission',
    Submitted: 'Submitted',
    TcApproved: 'TcApproved',
    New: 'New',
    InProcess: 'InProcess',
    ReadyForReview: 'ReadyForReview',
    NonReimbursable: 'NonReimbursable',
    Rejected: 'Rejected',
    NeedMoreInformation: 'NeedMoreInformation',
    ReturnedByAccounting: 'ReturnedByAccounting',
    OnHoldMatchPending: 'OnHoldMatchPending',
    OnHoldPendingAirfare: 'OnHoldPendingAirfare',
    OnHoldAirlineCreditOnFile: 'OnHoldAirlineCreditOnFile',
    OnHoldDisputed: 'OnHoldDisputed',
    OnHoldAdvancedDeposit: 'OnHoldAdvancedDeposit',
    OnHoldReimbursement: 'OnHoldReimbursement',
    Abandoned: 'Abandoned',
    Matched: 'Matched',
    Approved: 'Approved',
    Posted: 'Posted',
    Dispute: 'Dispute',
    ToBeSentToWorkday: 'ToBeSentToWorkday',
    AwaitingEndDate: 'AwaitingEndDate',
    MCOCredit: 'MCOCredit',
    Processed: 'Processed',
    Grouped: 'Grouped',
    InCorrection: 'InCorrection',
    Outdated: 'Outdated',
    Invoiced: 'Invoiced',
    InvoiceReview: 'InvoiceReview',
    ReviewOnHold: 'ReviewOnHold',
    WorkdayError: 'Workday Error',
};

const ExpenseAdminStatusValuesEnum = {
    Submitted: 'Submitted',
    TcApproved: 'TcApproved',
    NeedMoreInformation: 'NeedMoreInformation',
    InProcess: 'InProcess',
    NonReimbursable: 'NonReimbursable',
    InvoiceReview: 'InvoiceReview',
    InCorrection: 'InCorrection',
    OnHoldReimbursement: 'OnHoldReimbursement',
    ReviewOnHold: 'ReviewOnHold',
    Approved: 'Approved',
    Abandoned: 'Abandoned',
};

const NonClinicianReimbursementFeatureFlagFilteredStatusValuesEnum = {
    OnHoldMatchPending: 'OnHoldMatchPending',
    OnHoldPendingAirfare: 'OnHoldPendingAirfare',
    OnHoldAirlineCreditOnFile: 'OnHoldAirlineCreditOnFile',
    OnHoldDisputed: 'OnHoldDisputed',
    OnHoldAdvancedDeposit: 'OnHoldAdvancedDeposit',
    Matched: 'Matched',
    Rejected: 'Rejected',
};

const ExpenseStatusChipStyles = {
    chipOnHoldMatchPending: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldPendingAirfare: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldAirlineCreditOnFile: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldDisputed: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldAdvancedDeposit: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldReimbursement: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipReviewOnHold: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipInCorrection: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipReadyForReview: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipNeedsApproval: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipInProcess: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipNew: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipApproved: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipMatched: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipAbandoned: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipPosted: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipMissingInformation: {
        backgroundColor: COLORS.LT_PEPPER10,
        color: COLORS.LT_PEPPER,
        borderColor: COLORS.LT_PEPPER,
    },
    chipRejected: {
        backgroundColor: COLORS.LT_PEPPER10,
        color: COLORS.LT_PEPPER,
        borderColor: COLORS.LT_PEPPER,
    },
    chipNonReimbursable: {
        backgroundColor: COLORS.LT_PEPPER10,
        color: COLORS.LT_PEPPER,
        borderColor: COLORS.LT_PEPPER,
    },
    chipAssigned: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipUnassigned: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipTcApproved: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipNeedMoreInformation: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipReturnedByAccounting: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipPendingSubmission: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipSubmitted: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipGrouped: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipProcessed: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipDisputed: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipToBeSentToWorkday: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipAwaitingEndDate: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipMCOCredit: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOutdated: {
        backgroundColor: '#E5E8EA',
        color: '#2A3953',
        borderColor: '#2A3953',
    },
    chipInvoiced: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipInvoiceReview: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipAwaitingRefund: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipAnticipateRefund: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipAwaitingReceipt: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipHold: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
};

const ExpenseNewStatuses = [
    ExpenseStatusValuesEnum.Outdated,
    ExpenseStatusValuesEnum.Invoiced,
    ExpenseStatusValuesEnum.InvoiceReview,
    ExpenseStatusValuesEnum.ReviewOnHold,
];

const SplitExpenseTabDeleteBlockedStatuses = [
    ExpenseStatusValuesEnum.Approved,
    ExpenseStatusValuesEnum.Posted,
    ExpenseStatusValuesEnum.InCorrection,
    ExpenseStatusValuesEnum.Invoiced,
    ExpenseStatusValuesEnum.InvoiceReview,
];

const CreditCardPreProcessingApprovalBlockedStatuses = [
    ExpenseStatusValuesEnum.OnHoldMatchPending,
    ExpenseStatusValuesEnum.InProcess,
    ExpenseStatusValuesEnum.AwaitingEndDate,
    ExpenseStatusValuesEnum.MCOCredit,
];

export {
    ExpenseStatusEnum,
    ExpenseStatusChipStyles,
    ExpenseVaultStatusEnum,
    ExpenseStatusIdsEnum,
    ExpenseStatusValuesEnum,
    ExpenseAdminStatusValuesEnum,
    NonClinicianReimbursementFeatureFlagFilteredStatusValuesEnum,
    ExpensePaymentStatusEnum,
    ExpenseCreditCardStatusEnum,
    ExpenseClinicianReimbursementStatusEnum,
    ExpenseNewStatuses,
    SplitExpenseTabDeleteBlockedStatuses,
    CreditCardPreProcessingApprovalBlockedStatuses,
};
